import { BaseGraphQL } from "~/services/baseGraphQL";
import { GRAPHQL_AUTHENTICATION } from "~/constants/url";
import { JsonResponseType } from "~/types/jsonResponseType";
import { LoginResponse } from "../../../types/login";

const authenticationGraph = BaseGraphQL({
  baseUrl: GRAPHQL_AUTHENTICATION,
});

export const loginWithAzure = async (accessToken: string, idToken: string) => {
  const query = `
      query($accessToken: String!, $idToken: String!) {
      authenticate {
        authenticateWithAzure(
          authenticationWithAzureVM: {
            accessToken: $accessToken
            idToken: $idToken
          }
        ) {
          messageCode
          succeed
          data {
            userCompaniesInfo {
              companyId
              companyLogoURL
              companyType
              companyName
              isDemo
              tokenObject {
                token
                userName
              }
              userId
            }
            userName
          }
        }
      }
    }
  `;

  return await authenticationGraph<
    LoginResponse,
    {
      authenticate: {
        authenticateWithAzure: JsonResponseType<LoginResponse>;
      };
    }
  >(
    {
      action: "UserGraphQL",
      query,
      variables: {
        accessToken,
        idToken,
      },
    },
    (input) => input.authenticate.authenticateWithAzure,
  );
};
